// extracted by mini-css-extract-plugin
export default {"main":"Styles_main__hOgfF","editor":"Styles_editor__gABuW"};